import { render, staticRenderFns } from "./CouponForm.vue?vue&type=template&id=6a7eb0fd&scoped=true&"
import script from "./CouponForm.vue?vue&type=script&lang=js&"
export * from "./CouponForm.vue?vue&type=script&lang=js&"
import style0 from "./CouponForm.vue?vue&type=style&index=0&id=6a7eb0fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7eb0fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a7eb0fd')) {
      api.createRecord('6a7eb0fd', component.options)
    } else {
      api.reload('6a7eb0fd', component.options)
    }
    module.hot.accept("./CouponForm.vue?vue&type=template&id=6a7eb0fd&scoped=true&", function () {
      api.rerender('6a7eb0fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/CouponForm.vue"
export default component.exports